import { HttpMethod } from 'src/api';
import { ENV } from 'src/config/env';

export default class ActionDTO<Action = never> {
    public readonly localizedName: string;
    public readonly action: Action | HttpMethod;
    public readonly url?: string;
    public readonly endpoint?: string;
    public readonly method?: HttpMethod;
    public readonly descriptionTemplateKey?: string;

    constructor(json: any) {
        this.localizedName = json.localizedName;
        this.action = json.action;
        if (json.url && json.url !== '') {
            this.url = json.url;
            this.endpoint = json.url.replace(ENV.baseUrl, '');
            this.method = json.action;
        }
        this.descriptionTemplateKey = json.descriptionTemplateKey === '' ? undefined : json.descriptionTemplateKey;
    }

    public get isDispatchable(): boolean {
        return this.endpoint != null && ['POST', 'PATCH', 'PUT', 'DELETE'].some(method => this.action === method);
    }

    public is(action: Action | HttpMethod | (Action | HttpMethod)[]): boolean {
        if (Array.isArray(action)) {
            return action.includes(this.action);
        }
        return this.action === action;
    }

    public getDispatchable(method: HttpMethod): ActionDTO<Action> {
        return { ...this, method };
    }
}
